import React from "react"
interface ItemStatusProps {
  color: string
  backgroundColor: string
  classname?: string
}

const ItemStatus: React.FC<ItemStatusProps> = ({
  color = "",
  backgroundColor = "",
  classname = "",
}) => {
  return (
    <div className={`flex center-items gap-1 ${classname}`}>
      <span
        style={{
          width: "0.60rem",
          height: "0.60rem",
          borderRadius: "50%",
          backgroundColor: backgroundColor,
          border: `1px solid ${color}`,
        }}
      ></span>
    </div>
  )
}

export default ItemStatus
